<template>
  <DataListStateful
    title="Продавцы"
    resource="factories"
    store="factories"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Наименование", name: "title", sortable: true },
        {
          title: "Телефон ",
          name: "phone",
          valueFn(value) {
            if (value) {
              return value.Phones.join(", ");
            }
          },
          sortable: true,
        },
        {
          title: "Email",
          name: "email",
          valueFn(value) {
            if (value) {
              return value.Emails.join(", ");
            }
          },
          sortable: true,
        },
        { title: "Страна", name: "countries", sortable: true },
        { title: "Индекс", name: "postcodes", sortable: true },
        {
          title: "Автор",
          name: "author",
          dataPath: "Author.Title",
          sortable: true,
        },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        email: {
          title: "Email",
          type: "text",
        },
        phone: {
          title: "Телефон",
          type: "text",
        },
        countries: {
          title: "Страна",
          type: "text",
        },
        postcodes: {
          title: "Индекс",
          type: "text",
        },
        author: {
          title: "Автор",
          type: "text",
        },
      },
    };
  },
};
</script>
